export const DOWNLOAD_ACTION_TYPES = {
  GET_LIST_DOWNLOAD: "DOWNLOAD/GET_LIST",
  GET_LIST_DOWNLOAD_SUCCESS: "DOWNLOAD/GET_LIST_SUCCESS",
  GET_LIST_DOWNLOAD_FAILURE: "DOWNLOAD/GET_LIST_FAILURE",
};
